export default function (value) {
    return value?.replaceAll(/(https?\S+)/gi, '<a href="$1" target="_blank">$1</a>');
}
